import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import { Call } from '@gem/call/CallStore/Call';
import { useCallContext } from '@gem/call/CallView/CallView.context';

interface IPermissionsRequestHandlerPresenter {
  prevInitiatorOwnerOrAdmin: boolean | null;
  call: Call;
  isMeInitiatorOwnerOrAdmin: boolean;
  isCallStarted: boolean;
  channelId: string | null;
  getPermissionsData(): void;
  checkRoleChanged(): void;
}

export const usePermissionsRequestHandlerPresenter = (): void => {
  const context = useCallContext();

  const presenter = useLocalObservable<IPermissionsRequestHandlerPresenter>(() => ({
    prevInitiatorOwnerOrAdmin: null,

    get call(): Call {
      return context.call;
    },

    get isMeInitiatorOwnerOrAdmin(): boolean {
      return presenter.call.isMeInitiatorOwnerOrAdmin;
    },

    get isCallStarted(): boolean {
      return presenter.call.isStarted;
    },

    get channelId(): string | null {
      return presenter.call.channelId || null;
    },

    getPermissionsData(): void {
      if (presenter.channelId) {
        context.callController.getPermissionRequests(presenter.channelId);
        context.callController.getCallPermissions(presenter.channelId);
      }
    },

    checkRoleChanged(): void {
      if (
        presenter.isCallStarted &&
        presenter.prevInitiatorOwnerOrAdmin !== presenter.isMeInitiatorOwnerOrAdmin
      ) {
        presenter.getPermissionsData();
      }
      presenter.prevInitiatorOwnerOrAdmin = presenter.isMeInitiatorOwnerOrAdmin;
    },
  }));

  useEffect(() => {
    presenter.checkRoleChanged();
  }, [presenter.isMeInitiatorOwnerOrAdmin, presenter.isCallStarted]);
};
